var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancedAvatarCharacterFramework(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.756 95.8995C135.698 89.185 134.134 82.9207 133.932 76.5888C133.798 72.2719 128.955 68.7373 124.746 69.7054C114.685 72.0074 105.538 69.7223 96.8725 64.5611C92.2653 61.8145 87.3498 60.0416 81.9074 60.1879C76.863 60.3286 72.7154 62.0622 69.8064 66.5479C65.244 73.5889 63.4617 81.2828 63.8092 89.5733C63.8596 90.744 63.9101 91.9203 64.095 93.0685C64.2968 94.3011 63.7139 94.1154 62.9965 93.7946C60.3229 92.607 58.563 90.5245 57.3299 87.9299C55.5924 84.2715 55.0936 80.3316 55.1384 76.3749C55.2729 65.6924 57.0721 55.3194 61.7017 45.5994C66.5107 35.5247 73.8924 28.4049 85.0237 25.9003C92.8482 24.1443 100.577 25.1461 108.2 27.268C119.029 30.2847 128.961 35.3108 138.455 41.2205C144.172 44.7776 146.498 51.6104 144.452 58.1843C142.95 63.0077 142.048 67.8987 142.014 72.9473C141.998 75.0692 142.244 77.1742 142.513 79.2735C143.231 84.8681 141.79 89.7591 137.749 93.7777C137.239 94.2842 136.65 94.712 136.073 95.1453C135.776 95.3705 135.423 95.5224 134.756 95.8939V95.8995Z",
    fill: "url(#paint0_linear_35_671)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.011 174.966C84.6314 174.966 69.2571 174.949 53.8773 175C52.4985 175 52.1342 174.713 52.2182 173.272C52.5882 166.67 53.4962 160.192 56.3154 154.147C58.9049 148.592 62.7218 144.286 68.8031 142.451C70.0867 142.063 71.3926 141.883 72.7266 141.804C75.0582 141.663 77.3674 141.348 79.5197 140.363C80.1755 140.065 80.8088 140.082 81.4646 140.239C89.7262 142.237 98.0943 142.918 106.563 142.187C110.431 141.849 114.264 141.275 118.031 140.318C118.967 140.082 119.825 140.042 120.755 140.476C122.638 141.348 124.684 141.675 126.735 141.765C134.195 142.074 139.223 146.082 142.76 152.34C145.428 157.068 146.588 162.269 147.266 167.593C147.518 169.58 147.535 171.595 147.771 173.581C147.905 174.701 147.58 175.011 146.465 174.994C142.188 174.932 137.917 174.972 133.641 174.972C122.425 174.972 111.215 174.972 100 174.972L100.011 174.966Z",
    fill: "url(#paint1_linear_35_671)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.757 123.175C86.2007 123.152 74.1726 113.438 70.7256 98.8603C68.876 91.0313 68.5005 83.2305 71.3365 75.5197C72.0147 73.6849 72.9788 72.002 73.9036 70.291C76.0503 66.3175 79.5757 65.4563 83.6393 65.7434C87.4843 66.0135 90.9537 67.4375 94.2325 69.3905C102.304 74.1858 110.924 76.7805 120.391 75.9419C121.988 75.8011 123.563 75.4466 125.149 75.2158C127.318 74.9062 128.574 75.9531 128.624 78.1425C128.703 81.8797 129.364 85.5775 129.521 89.2866C130.182 104.871 121.601 120.377 104.075 122.994C102.982 123.158 101.861 123.118 100.751 123.169L100.757 123.175Z",
    fill: "url(#paint2_linear_35_671)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.073 136.953C95.6842 136.947 91.3292 136.592 87.0022 135.821C86.2119 135.681 85.8476 135.545 86.4025 134.718C87.8093 132.613 88.751 130.317 89.1041 127.795C89.2274 126.929 89.5469 126.771 90.4324 127.047C96.8276 129.022 103.279 129.281 109.747 127.418C110.52 127.199 110.84 127.283 110.963 128.139C111.305 130.486 112.196 132.636 113.502 134.6C114.029 135.393 113.979 135.658 112.964 135.833C108.693 136.587 104.394 136.924 100.062 136.953H100.073Z",
    fill: "url(#paint3_linear_35_671)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.009 93.2601C48.0594 94.0874 47.5438 94.594 47.0337 95.1174C44.8198 97.38 42.6451 99.682 40.3807 101.894C39.5792 102.676 39.6465 103.132 40.4199 103.869C42.6675 106.014 44.8534 108.231 47.0449 110.438C48.2276 111.625 48.4069 112.835 47.4765 113.595C46.2939 114.569 45.3635 113.967 44.4555 113.049C41.681 110.246 38.873 107.483 36.0873 104.691C34.6581 103.262 34.6413 102.603 36.0089 101.185C38.8618 98.2242 41.7315 95.2863 44.59 92.3314C45.2682 91.6335 46.0192 91.2789 46.9721 91.6898C47.6446 91.9824 47.9529 92.5453 48.009 93.2601Z",
    fill: "url(#paint4_linear_35_671)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.957 112.188C151.918 111.445 152.406 110.983 152.882 110.511C155.006 108.394 157.086 106.228 159.277 104.184C160.292 103.239 160.505 102.665 159.361 101.595C157.131 99.5186 155.079 97.2448 152.927 95.0722C151.997 94.1323 151.475 93.0911 152.552 92.0386C153.622 90.9917 154.659 91.532 155.573 92.4776C158.386 95.3987 161.228 98.286 164.036 101.213C165.297 102.524 165.325 103.25 164.109 104.483C161.183 107.443 158.207 110.364 155.27 113.314C154.62 113.961 153.891 114.287 153.022 113.916C152.305 113.612 151.913 113.015 151.957 112.182V112.188Z",
    fill: "url(#paint5_linear_35_671)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_671",
    x1: 100.16,
    y1: 24.9995,
    x2: 100.16,
    y2: 95.8995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_671",
    x1: 100.003,
    y1: 140.128,
    x2: 100.003,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_671",
    x1: 99.4147,
    y1: 65.6929,
    x2: 99.4147,
    y2: 123.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_671",
    x1: 99.9842,
    y1: 126.923,
    x2: 99.9842,
    y2: 136.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35_671",
    x1: 41.5343,
    y1: 91.5151,
    x2: 41.5343,
    y2: 114.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35_671",
    x1: 158.476,
    y1: 91.4678,
    x2: 158.476,
    y2: 114.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 150,
    fill: "white",
    transform: "translate(35 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedAvatarCharacterFramework);
export default __webpack_public_path__ + "static/media/Advanced_Avatar_&_Character_Framework.fd87fe80afa0021e083b44fef2f55d28.svg";
export { ForwardRef as ReactComponent };